import * as React from 'react'

import { EventModel } from '@/app/models/newDelegation/eventModel'
import { eventKey } from '@/app/common/newDelegation/eventIdentity'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import { useTimelineData } from '../context/DataContext'
import { DelegationMarkerBlock } from '../blocks/DelegationMarkerBlock'
import { LayerWrapper } from './LayerWrapper'
import { assignPointLanes, MARKER_BOX_WIDTH, MAX_MARKER_LANES } from './pointLanes'
import { LayerProps } from './types'

const DelegationMarkersLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const scene = useScene()
  const { delegationMarkers, allTripEvents } = useTimelineData()
  const { stackOverlappingMarkers } = useConfig()

  const markers: ReadonlyArray<{ event: EventModel; current: boolean }> =
    React.useMemo(
      () => [
        ...(allTripEvents || []).map((event) => ({ event, current: false })),
        ...(delegationMarkers || []).map((event) => ({ event, current: true })),
      ],
      [allTripEvents, delegationMarkers],
    )


  const lanes = React.useMemo(
    () =>
      stackOverlappingMarkers
        ? assignPointLanes(
            markers.map((m) => scene.timeToX(m.event.date)),
            { boxWidth: MARKER_BOX_WIDTH, maxLanes: MAX_MARKER_LANES },
          )
        : [],
    [stackOverlappingMarkers, markers, scene],
  )

  return (
    <LayerWrapper zIndex={zIndex}>
      {markers.map((item, index) => (
        <DelegationMarkerBlock
          key={stackOverlappingMarkers ? eventKey(item.event) : index}
          delegationMarker={item.event}
          current={item.current}
          index={index}
          lane={stackOverlappingMarkers ? lanes[index] : 0}
        />
      ))}
    </LayerWrapper>
  )
}

export default DelegationMarkersLayer
